import type { ConfluenceFilters } from '@atlassian/search-client';

import type { SelectedFiltersType } from '../../../../common/constants/types';

export const mapFiltersToAggregator = (
	filters: ConfluenceFilters,
): {
	[key: string]: any;
	'@type': string;
}[] => {
	const selectedFilters: Array<{ '@type': string; [key: string]: any }> = [];
	if (!filters) {
		return selectedFilters;
	}
	if (filters.spacesFilter.length > 0) {
		selectedFilters.push({
			'@type': 'spaces',
			spaceKeys: filters.spacesFilter,
		});
	}

	if (filters.isVerified) {
		selectedFilters.push({
			'@type': 'isVerified',
			isVerified: filters.isVerified,
		});
	}

	if (filters.contributorsFilter.length > 0) {
		selectedFilters.push({
			'@type': 'contributors',
			accountIds: filters.contributorsFilter,
		});
	}

	if (filters.range.length > 0) {
		selectedFilters.push({
			'@type': 'lastModified',
			from: filters.range[0].gt,
			to: filters.range[0].lt,
		});
	}

	if (filters.ancestorIdsFilter.length > 0) {
		selectedFilters.push({
			'@type': 'ancestorIds',
			ancestorIds: filters.ancestorIdsFilter,
		});
	}

	if (filters.labelsFilter.length > 0) {
		selectedFilters.push({
			'@type': 'labels',
			labelIds: filters.labelsFilter,
		});
	}

	return selectedFilters;
};

export const mapSelectedFiltersToAggregator = function mapSelectedFiltersToAggregator(
	selectedFilters: SelectedFiltersType,
): {
	commonFilters: Array<{ '@type': string; [key: string]: any }>;
	confluenceFilters: Array<{ '@type': string; [key: string]: any }>;
} {
	const mappedFilters: {
		commonFilters: Array<{ '@type': string; [key: string]: any }>;
		confluenceFilters: Array<{ '@type': string; [key: string]: any }>;
	} = { commonFilters: [], confluenceFilters: [] };

	if (!selectedFilters) {
		return mappedFilters;
	}

	const { commonFilters, confluenceFilters } = selectedFilters;

	if (commonFilters && Object.keys(commonFilters).length > 0) {
		if (commonFilters.range?.lastModified) {
			if (commonFilters.range.lastModified.gt && commonFilters.range.lastModified.lt) {
				mappedFilters.commonFilters.push({
					'@type': 'lastUpdated',
					from: commonFilters.range.lastModified.gt,
					to: commonFilters.range.lastModified.lt,
				});
			} else if (commonFilters.range.lastModified.gt) {
				mappedFilters.commonFilters.push({
					'@type': 'lastUpdated',
					from: commonFilters.range.lastModified.gt,
				});
			} else if (commonFilters.range.lastModified.lt) {
				mappedFilters.commonFilters.push({
					'@type': 'lastUpdated',
					to: commonFilters.range.lastModified.lt,
				});
			}
		}

		if (commonFilters.contributorsFilter && commonFilters.contributorsFilter.length > 0) {
			mappedFilters.commonFilters.push({
				'@type': 'contributors',
				accountIds: commonFilters.contributorsFilter,
			});
		}
	}

	if (confluenceFilters && Object.keys(confluenceFilters).length > 0) {
		mappedFilters.confluenceFilters = mapFiltersToAggregator(confluenceFilters);
	}

	return mappedFilters;
};
